import { render, staticRenderFns } from "./SiteNav.vue?vue&type=template&id=50f36be4&scoped=true"
import script from "./SiteNav.vue?vue&type=script&lang=ts"
export * from "./SiteNav.vue?vue&type=script&lang=ts"
import style0 from "./SiteNav.vue?vue&type=style&index=0&id=50f36be4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f36be4",
  null
  
)

export default component.exports